import { Layer } from '../../types'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import { Button } from '../Button'
import Styles from './BottomMessage.module.scss'
import { ReactComponent as MergeIcon } from 'assets/icons/mergeBranch16.svg'
import { CleanupModeActionParam } from 'stores/CleanupMode'
import { DocMode } from 'stores/DocStore.types'
import { useDocStore } from 'stores/DocStore'
import { MergeLayerModal } from '../MergeLayerModal/MergeLayerModal'
import { useModals } from 'almanac-ui/Modal'

interface Props {
  layer: Layer
}

export const MergeLayerButton = ({ layer }: Props) => {
  const { openModal, closeAllModals } = useModals()
  const docStore = useDocStore()
  const history = useHistory()
  const { pathname, search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  const handleDeleteSuccess = () => {
    searchParams.delete(CleanupModeActionParam)
    if (!layer.parent_layer) {
      searchParams.delete('layer')
    } else {
      searchParams.set('layer', layer.parent_layer.id)
    }
    history.push({ pathname, search: searchParams.toString() })
    docStore.setDocMode(DocMode.Editor)
  }

  const handleMerge = () => {
    openModal(MergeLayerModal, {
      onComplete: () => {
        handleDeleteSuccess()
        closeAllModals()
      },
      layer,
      suggestionsCount: 0,
      commentsCount: 0,
      includedChanges: docStore.cleanupModeStore.cleanedUpTrackedChangesCount,
    })
  }

  return (
    <Button
      className={Styles.leaveButton}
      size="md"
      frontIcon={MergeIcon}
      onPress={handleMerge}
      iconClassName={Styles.buttonIcon}
    >
      Merge Layer
    </Button>
  )
}
